import { sliderAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle(() => ({
  flex: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  mark: {
    mt: '1',
    minW: '100px',
  },
}));

export const Slider = defineMultiStyleConfig({
  baseStyle,
  variants: {
    vertical: {
      mark: {
        fontSize: 'sm',
        ml: '2.5',
        mb: '-2',
      },
    },
    horizontal: {
      mark: {
        fontSize: 'sm',
        ml: '-2.5',
      },
    },
  },
});
